import React, { useState, useEffect, useCallback } from "react"
import UserBar from "../shared/UserBar"
import { Container, Button, List, Header, Label } from "semantic-ui-react"
import { Link } from "react-router-dom"

import { getSessions, revokeSession, revokeOtherSessions } from "../../api/auth"
import { describeDevice, describeLastUsed } from "../../utils/device"

const User = (props) => {
	const { user } = props

	// Get tempMeasure from localStorage, default to true (Fahrenheit)
	const getTempMeasure = () => {
		const saved = localStorage.getItem("tempMeasure")
		return saved !== null ? saved === "true" : true
	}
	const [tempMeasure, setTempMeasure] = useState(getTempMeasure)
	const [sessions, setSessions] = useState([])

	// Update localStorage when tempMeasure changes
	useEffect(() => {
		localStorage.setItem("tempMeasure", tempMeasure.toString())
	}, [tempMeasure])

	const changeTempMeasure = () => {
		setTempMeasure((prev) => {
			const newValue = !prev
			// Dispatch custom event so Home component can update immediately
			window.dispatchEvent(new Event("tempMeasureChanged"))
			return newValue
		})
	}

	const loadSessions = useCallback(() => {
		if (!user) {
			setSessions([])
			return
		}
		getSessions(user)
			.then((res) => setSessions(res.data.sessions))
			// a 401 here is handled globally by the axios interceptor
			.catch(() => setSessions([]))
	}, [user])

	useEffect(loadSessions, [loadSessions])

	const onRevoke = (sessionId) => {
		revokeSession(user, sessionId)
			.then(loadSessions)
			.catch(() => {})
	}

	const onRevokeOthers = () => {
		revokeOtherSessions(user)
			.then(loadSessions)
			.catch(() => {})
	}

	let buttons
	if (user === null) {
        buttons =
		<>

			<Link to="/sign-up">
				<Button className="usr-btn" size="huge">
					Sign Up
				</Button>
			</Link>
			<Link to="/sign-in">
				<Button size="huge" className="usr-btn">
					Sign In
				</Button>
			</Link>
		</>
	} else {
        buttons =
        <>

        <Link to="/sign-out">
        <Button size="huge" className="usr-btn">
            Sign Out
        </Button>
    </Link>
    <Link to='/my-posts'>
    <Button size='huge' className="usr-btn">My Posts</Button></Link>
        </>

    }

	// only meaningful when signed in, and only worth showing once we know of
	// more than the device being used right now
	let deviceList
	if (user !== null && sessions.length > 0) {
		const others = sessions.filter((session) => !session.current)

		deviceList = (
			<div className="user-devices">
				<Header as="h4" inverted>
					Signed-in devices
				</Header>
				<List divided relaxed inverted>
					{sessions.map((session) => (
						<List.Item key={session._id}>
							<List.Content
								floated="right"
								style={{ marginLeft: "1em" }}
							>
								{session.current ? (
									<Label >This device</Label>
								) : (
									<Button
										size="small"
										onClick={() => onRevoke(session._id)}
									>
										Sign out
									</Button>
								)}
							</List.Content>
							<List.Content>
								<List.Header>
									{describeDevice(session.userAgent)}
								</List.Header>
								<List.Description>
									Last used{" "}
									{describeLastUsed(session.lastUsedAt)}
								</List.Description>
							</List.Content>
						</List.Item>
					))}
				</List>
				{others.length > 0 && (
					<Button size="small" onClick={onRevokeOthers}>
						Sign out other devices ({others.length})
					</Button>
				)}
			</div>
		)
	}

	return (
		<Container as="nav">
			<UserBar />
			<div className="user-buttons">
			{buttons}
			<Button
				size="huge"
				className="usr-btn"
				onClick={changeTempMeasure}
			>
				Change Temp Measure ({tempMeasure ? "°F" : "°C"})
			</Button>
			</div>
			{deviceList}
		</Container>
	)
}

export default User
